import {
  Box,
  CircularProgress,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

import {
  selectImpactCalculateFestivalCo2ForProject,
  selectImpactCalculateFestivalEnvForProject,
  selectImpactCalculateFestivalEssForProject,
} from '@/domain/impact-calculate-festival/impact-calculate-festival.selectors';
import { ProjectFestival } from '@/domain/project-festival/entities/project-festival.entity';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { ScoresBySectorCards } from '@/ui/pages/app/project/festival/project/components/ScoresBySector/ScoresBySectorCards';
import { Fonts } from '@/ui/theme/fonts';

export function ScoresBySector({ project }: { project: ProjectFestival }) {
  const calculateCo2 = useAppSelector(
    selectImpactCalculateFestivalCo2ForProject(project.id),
  );
  const calculateEnv = useAppSelector(
    selectImpactCalculateFestivalEnvForProject(project.id),
  );
  const calculateEss = useAppSelector(
    selectImpactCalculateFestivalEssForProject(project.id),
  );

  return (
    <Stack spacing={2} sx={{ paddingY: 2 }}>
      <Box sx={{ paddingX: 2 }}>
        <TitleAndDescription />
        <TotalCompleteCo2 totalCompletionCo2={calculateCo2.completion} />
      </Box>
      <Divider />
      {project.id && (
        <ScoresBySectorCards
          calculateCo2={calculateCo2}
          calculateEss={calculateEss}
          calculateEnv={calculateEnv}
          projectId={project.id}
        />
      )}
      <Divider />
    </Stack>
  );
}

function TitleAndDescription() {
  return (
    <>
      <Stack
        direction={'row'}
        spacing={2}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography variant="h6">
          {translate('Projects.ScoresBySector.scores-by-sector')}
        </Typography>
      </Stack>
      <Typography sx={{ marginY: 2 }}>
        {translate('Projects.ScoresBySector.description')}
      </Typography>
    </>
  );
}

function TotalCompleteCo2({
  totalCompletionCo2,
}: {
  totalCompletionCo2: number;
}) {
  return (
    <Stack direction={'row'} alignItems={'center'} spacing={2}>
      <CircularProgress
        size={18}
        variant="determinate"
        value={Math.floor(totalCompletionCo2 * 100)}
      />
      <Typography
        sx={{
          fontSize: '1.875rem',
          fontWeight: '900',
          fontFamily: Fonts.DarkerGrotesque,
        }}
      >
        {Math.floor(totalCompletionCo2 * 100)}%
      </Typography>
      <Typography sx={{ mt: 1 }} color="text.secondary">
        {translate('Projects.ScoresBySector.total-complete-co2')}
      </Typography>
    </Stack>
  );
}
